import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './FullScreenNavbar.css'

const FullScreenNavbar = ({ bgcolor = '#fff' }) => {
    const [menuOpen, setMenuOpen] = useState(false)
    const [dropdownOpen, setDropdownOpen] = useState(false)


    const close = () => {
        setMenuOpen(false)
        setDropdownOpen(false)
    }


    return (
        <header className="navbar">
            <div 
                className="navbar__bar"
                style={{
                    transition: 'transform 0.3s ease'
                }}
            >
                <Link to="/" className="navbar__logo">Gladious</Link>

                <button
                    className={`navbar__toggle${menuOpen ? ' is-open' : ''}`}
                    onClick={() => setMenuOpen(o => !o)}
                >
                    <span /><span /><span />
                </button>
            </div>

            <nav className={`navbar__drawer${menuOpen ? ' is-open' : ''}`}>
                <Link to="/" className="navbar__link" onClick={close}>Home</Link>

                <div className="navbar__dropdown">
                    <button
                        className="navbar__link navbar__dropdown-toggle"
                        onClick={() => setDropdownOpen(o => !o)}
                    >
                        Properties
                    </button>

                    <div className={`navbar__dropdown-menu${dropdownOpen ? ' is-open' : ''}`}>
                        <Link to="/for-sale" className="navbar__sublink" onClick={close}>For Sale</Link>
                        <Link to="/for-rent" className="navbar__sublink" onClick={close}>For Rent</Link>
                        <Link to="/upcoming-projects" className="navbar__sublink" onClick={close}>Upcoming Projects</Link>
                        <Link to="/ongoing-projects" className="navbar__sublink" onClick={close}>Ongoing Projects</Link>
                    </div>
                </div>

                <Link to="/aboutus" className="navbar__link" onClick={close}>About</Link>
                <Link to="/contact" className="navbar__link" onClick={close}>Contact Us</Link>
            </nav>

            {menuOpen && <div className="navbar__backdrop" onClick={close} />}
        </header>
    )
}

export default FullScreenNavbar